<template>
    <div class="tab-page">
        <zlm-mobile-dynamic-list
            :config="config"
            type="line"
            @onLoad="onLoad"
            @onRefresh="onRefresh"
            @handleClick="handleClick"
        />
    </div>
</template>

<script>
    import mixin from '@/components/mixin/tabMixin'
    export default {
        name: 'TabPage',
        mixins: [mixin],
        data() {
            return {
                config: require(`@/config/${process.env.VUE_APP_PROJECT}/${this.$route.query.id}`),
                pageSize: 15,
            }
        },
    }
</script>

<style>
.tab-page{
    padding: 10px 0;
}
</style>
